import store from '@/store';

export default class AgentWhatsAppLogoffEvent {
  constructor(body) {
    if (body.whatsAppLogoff) {
      store.dispatch('channel/setDisconnectedInwhatsApp');
    } else {
      store.dispatch('showSnackbar', {
        text: 'errorDisconnectChannel',
        type: 'error',
      });
    }
  }
}
